import '@zebra-fed/icons/Enterprise/index.css';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { useHistory } from "react-router";
import styled from 'styled-components';
import { AuthContext } from '../../../authentication/Auth';
import app from '../../../authentication/firebaseStart';
import { ContentWrapper, PageTitle, SnackbarContent } from '../../../styled-components/shared';
import { useTranslation } from "react-i18next";
import SummaryContainer from "../Components/SummaryContainer"
import DevicesList from "./DevicesListDashboard";
import DropdownCustom from '../../../components/DropdownCustom';
import { CircularProgress, Snackbar } from '@material-ui/core';
import BottomNavLinks from '../../../components/BottomNavLinks';
import firebaseUtil from "../../../data/FirebaseUtil";
import { getURLFromGCSBucket } from "../../commonUtils/ExportUtils";
import AlertModal from '../../../components/modals/AlertModal';
import { userJustManager } from '../../../data/userUtil';
import './css/devicesDashboard.css';

const firestore = app.firestore();

const MainContent = styled.div`
  // border-top: 2px solid #e1e1e1;
  borer-bottom: none;
  // border: 1px solid #bdbdbd;
  margin-top: 50px;

  .MuiTableHead-root {
    display: contents;
  }
`;

const StyledHeader = styled(PageTitle)`
  // min-width: 1020px;
`;


const SummaryContainerStyled = styled.div`
  margin-top: 2%;
  font-size: 15px;
`;

const SiteData = styled.div`
    display: flex;
    margin-bottom: 8px;
    color: black;  
`;

const SiteNameLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
`;

const StyledTextField = styled.div`
  margin-left: 10px;
  font-size: 16px;
`;

const PageTitleTop = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 27px;
  color: #007ABA;
  ${'' /* width: 100%; */}
  @media screen and (max-width: 700px){
    flex-direction: column;
  }
`;

const imgStyleLoader = {
  width: 18,
  height: 18,
  marginTop: 6,
  marginLeft: -15,
  marginRight: 5,
}
export default function DevicesDashboard(props) {

  const context = useContext(AuthContext);
  let siteNameAssigned = "";
  const isManager = userJustManager(context.currentUser.claims)
  if (isManager) {
    siteNameAssigned = context.currentUser.claims.siteArr[0];
    siteNameAssigned = siteNameAssigned.toUpperCase();

  }

  const { t } = useTranslation();
  const history = useHistory();
  const { listDropDown, setListDropDown, setTitle } = props;
  const [loggedInUser, setLoggedInUser] = useState(null);
  let [dropDownvalue, setDropdownValue] = useState(isManager ? siteNameAssigned :"All Devices");
  const [siteData, setSIteData] = useState([]);
  const [selectedSiteIndex, setSelectedSiteIndex] = useState(null);
  const [allSiteNames, setAllSiteNames] = useState([])
  const [sitesOld, setSitesOld] = useState([{ label: "All Devices", value: "All Devices" }])
  const DEFAULT_ROWS_PER_PAGE = 10;
  const [sitesFilterVal, setSitesFilterVal] = useState({})
  const alertModalRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [searchField, setSearchField] = useState('');
  const [searchString, setSearchString] = useState('');

  const [deviceCount, setDeviceCount] = useState(0);

  const getDeviceCount = (e)=>{
    setDeviceCount(e)

  }

  const getDevSearchData = (searchVal,opt)=>{
    setSearchString(searchVal);
    setSearchField(opt)
  }

  const snackBarContent = useRef();
  const isSnackbarFailure = useRef();
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [pageSize, setPageSize] = useState(DEFAULT_ROWS_PER_PAGE);
  const [isLoading, setIsLoading] = useState(false);
  const [siteDefaultValue, setSiteDefaultValue] = useState(isManager ? { label: siteNameAssigned, value: siteNameAssigned} :{ label: 'All Devices', value: 'All Devices' })
  // const params = new URLSearchParams(window.location.search)
  const [exportBtnState, setexportBtnState] = useState('none')
  useEffect(() => {
    if (sessionStorage.getItem("selectedSite") != null && sessionStorage.getItem("selectedSite") != "ALL SITES") {

      setSitesFilterVal({ label: sessionStorage.getItem("selectedSite"), value: sessionStorage.getItem("selectedSite") })
      setDropdownValue(sessionStorage.getItem("selectedSite"))

    }
    setLoggedInUser(context.currentUser.email);
    getSitesData(pageSize);
    let dropDownId = document.getElementById('dropDown')
    console.log(dropDownId, 'asdasdas')
    if (dropDownId) {
      console.log('cem')
      return () => {
      };
    }
  }, []);


  async function getSitesData(currentPageSize) {
    setIsLoading(true)
    let itemsPerPage = currentPageSize; /* Should be fetched dynamically from UI */
    let companyID = context.currentUser.claims.companyID;
    let sites = [];
    let finalSitesArray = []
    let finalSitesArrayNew = allSiteNames;

    if(isManager){
      context.currentUser.claims.siteArr.forEach(el=>{
         finalSitesArray.push({name:el})
        finalSitesArrayNew.push({ label: el, value: el });
      });
    }
    else{
      sites = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('SiteLocations')
          .limit(itemsPerPage)
          .get()
      ).docs.map((doc) => doc.data());

      Object.keys(sites).forEach(site => {
        finalSitesArray.push({ name: sites[site].siteName })
      });
      finalSitesArray.unshift({ name: 'Unassigned Devices' });
      finalSitesArray.unshift({ name: 'All Devices' });
      Object.keys(finalSitesArray).forEach((site, index) => {
        if (site === "All Sites") {
          setSelectedSiteIndex(index)
          return;
        }
        return
      })
      Object.keys(sites).forEach(site => {
        finalSitesArrayNew.push({ label: sites[site].siteName, value: sites[site].siteName })
      })
      finalSitesArrayNew.unshift({ label: 'Unassigned Devices', value: 'Unassigned Devices' });
      finalSitesArrayNew.unshift({ label: 'All Devices', value: 'All Devices' });
    }
     
    let test = []
    finalSitesArray.forEach((i) => {
      let newObj = { label: i.name, value: i.name }
      return test.push(newObj)
    });
    setSIteData(test);
    setSitesOld(finalSitesArrayNew)
    setAllSiteNames(finalSitesArrayNew)
    setIsLoading(false);
  }

  function onFilterChange(e, filterName) {
    setTitle("")
    if (filterName === 'SITES_FILTER') {
      setSitesFilterVal(e.target)
      setDropdownValue(e.target?.value)
      sessionStorage.setItem("selectedSite", e.target?.value)
    }
  }

  function getSelectInputSearch(rawInput, type) {
    if (type === 'ENTERHIT') {
      if(rawInput !== '' ){
        searchSiteName(rawInput)
      }
    }
  }

  async function searchSiteName(value) {
    let companyID = context.currentUser.claims.companyID;
    let sites = [];
    setIsLoading(true);
    sites = (
      await firestore
        .collection('tenants')
        .doc(companyID)
        .collection('SiteLocations')
        .orderBy('siteName')
        .startAt(value.toUpperCase()).endAt(value.toUpperCase() + "\uf8ff")
        .limit(10)
        .get()
    ).docs.map((doc) => doc.data());

    let finalSitesArray = []
    if(!isManager){
      finalSitesArray.push({ label: "All Devices", value: "All Devices" })
      finalSitesArray.push({ label: 'Unassigned Devices', value: 'Unassigned Devices' })
    }

    const siteSet = new Set(context.currentUser.claims.siteArr);
    sites.forEach(element => {
      if(isManager){
        if(siteSet.has(element.siteName)){
          finalSitesArray.push({ label: element.siteName, value: element.siteName })
        } 
      } else {
        finalSitesArray.push({ label: element.siteName, value: element.siteName })
      }
    });


    if(finalSitesArray.length === 0){
      siteSet.forEach(value => {
        finalSitesArray.push({ label: value, value: value })
      });
    }

    setAllSiteNames(finalSitesArray)
    setIsLoading(false);

  }

  function customFilterSearch(option, rawInput) {
    return allSiteNames;
  }

  const [summaryData, setsummaryData] = useState()

const getSummaryCount = (e)=>{
  console.log(e,summaryData,'props?.selectedTitle')
  setsummaryData(e)

}

  async function showSnackBar(content, isFailure) {
    snackBarContent.current = content;
    isSnackbarFailure.current = isFailure;
    setIsSnackBarOpen(true);
  }

  async function exportcsv() {
  console.log('mdv deviceCount',deviceCount)
  if(deviceCount){
      let companyID = context.currentUser.claims.companyID;
      let data = {
        "entityType": "devices",
        "site": dropDownvalue,
        "tile": props?.selectedTitle?.title ? props?.selectedTitle?.title : props?.selectedTitle,
        "searchField": searchField,
        "searchText": searchString
    }
    setexportBtnState('exporting')
      let response = await firebaseUtil.exportConfiguration(data, t);
    console.log(response, 'response');
    console.log(response.msg, 'response.msg');
      if (response?.status) {
      console.log(response.msg.filePath, 'response.msg.filePath');
        let url = response.msg.filePath;
      let fileName = url.substr(url.lastIndexOf('/') + 1);
      console.log(fileName, 'fileName')
      console.log(url, 'my url ')
      console.log(response.msg.jobId, 'response.msg.jobId');
        let jobId = response.msg.jobId;
        const ref = firestore.collection('tenants').doc(companyID).collection('Jobs').doc(jobId);
      console.log(ref, 'ref')
        ref.onSnapshot((querySnapshot) => {
        console.log(querySnapshot, 'querySnapshot')
          let items = querySnapshot.data();
        console.log(items, 'items',items.status === 2)
          if (items.status === 2) {
            async function getURL() {
            setexportBtnState('down')
            let result = await getURLFromGCSBucket(url,companyID,'devices');
            setexportBtnState('none')
            
            }
            getURL();

          }
      })
    }
    else {
        setexportBtnState('none');
      showSnackBar(t('error'),true);
      }
    } else {
      setErrorMessage('Export cannot be performed for empty records');
      alertModalRef.current.open();
    }

  }

  return (
    <ContentWrapper className={isLoading ? "loading" : ""}>
      {/* {isLoading && (
        <div className="loading-spinner">
          <CircularProgress />
        </div>
      )} */}
      <div>
        <div className="page-header">
          <PageTitleTop>{t("mobileDevices")}</PageTitleTop>

          <button
            id="download-data"
            className={`export-button ${exportBtnState}`}
            onClick={exportcsv}
          >
          {exportBtnState != 'none' ?
            <img src={process.env.PUBLIC_URL + '/csv_export.gif'} style={imgStyleLoader} /> : ""}
          {`${exportBtnState == 'none' ? t('exportingData') :
            exportBtnState == 'exporting' ? t('exporting') :
            exportBtnState == 'down' ? t('downloading') : null}`}
          </button>
        </div>

        <div className="dropdown-container">
          <span className="devices-dash-drop">
            <div>
              <DropdownCustom
                selectOpts={allSiteNames}
                onChange={(e) => onFilterChange(e, "SITES_FILTER")}
                selectVal={sitesFilterVal.label ? sitesFilterVal : siteDefaultValue}
                isSearchable={true}
                onSearchInpChange={getSelectInputSearch}
                isLoading={isLoading}
                customFilterOption={customFilterSearch}
              />
            </div>

            {siteData && (
              <div>
                <SummaryContainer
                  containerOf="Mobile"
                  fromWhere="devicesBoard"
                  sitevalue={dropDownvalue}
                  selectedTitle={props?.selectedTitle}
                  setTitle={props?.setTitle}
                  getSummaryCount={getSummaryCount}
                />
              </div>
            )}
          </span>
        </div>
      </div>

      <MainContent>
        <DevicesList
          historyObject={history}
          sitevalue={dropDownvalue}
          selectedTitle={props?.selectedTitle}
          setTitle={props?.setTitle}
          selectedTileObj={props}
          summaryData={summaryData}
          onFilterChange={onFilterChange}
          getDeviceCount={getDeviceCount}
          devSearchField={getDevSearchData}
        />
      </MainContent>
      <div>
        <Snackbar
          open={isSnackBarOpen}
          autoHideDuration={5000}
          onClose={() => {
            setIsSnackBarOpen(false);
          }}
        >
          <SnackbarContent error={isSnackbarFailure.current ? true : false}>
            {snackBarContent.current}
          </SnackbarContent>
        </Snackbar>
      </div>
      <BottomNavLinks />
      <AlertModal modalRef={alertModalRef} message={errorMessage} />
    </ContentWrapper>
  );
}